import { vEquipmentType } from '../equipment/utils.ts'
import { vCurrency, type vOutput } from '../validation/index.ts'
import {
  asLoadRef,
  vArray,
  vBoolean,
  vDate,
  vEmail,
  vMaxLength,
  vMinLength,
  vNonEmptyString,
  vObject,
  vOptional,
  vPipe,
  vString,
  vStringToNumber,
} from '../validation/schema/core.ts'

export const requestSpotQuotesCommand = vObject({
  loadId: vNonEmptyString(),
  userId: vNonEmptyString(),
  emails: vArray(vEmail),
  messageText: vNonEmptyString(),
  spotQuoteGroupIds: vOptional(vArray(vString())),
  prefixMessage: vOptional(vBoolean()),
})

export type RequestSpotQuotesCommand = vOutput<typeof requestSpotQuotesCommand>

export const requestSpotQuotesWithEquipmentCommand = vObject({
  ...requestSpotQuotesCommand.entries,
  equipmentTypes: vOptional(vArray(vEquipmentType())),
})

export type RequestSpotQuotesWithEquipmentCommand = vOutput<
  typeof requestSpotQuotesWithEquipmentCommand
>

const bidExpirationSchema = vObject({
  utc: vDate(),
  local: vString(),
})

export const createSpotQuoteRequestSchema = vObject({
  equipmentTypes: vOptional(
    vPipe(
      vArray(vEquipmentType()),
      vMinLength(1, 'At least one equipment type is required'),
    ),
  ),
  emails: vArray(vEmail),
  shipperMessage: vOptional(vPipe(vString(), vMaxLength(500))),
  selectedGroupIds: vOptional(vArray(vString())),
  targetPrice: vOptional(vStringToNumber()),
  targetPriceCurrency: vOptional(vCurrency()),
  bidExpiration: vOptional(bidExpirationSchema),
})

export type CreateSpotQuoteRequestDTO = vOutput<
  typeof createSpotQuoteRequestSchema
>

export const spotQuotePreviewSchema = vObject({
  loadId: asLoadRef(vNonEmptyString()),
  equipmentTypes: vOptional(vArray(vEquipmentType())),
  shipperMessage: vOptional(vPipe(vString(), vMaxLength(500))),
  targetPrice: vOptional(vStringToNumber()),
  targetPriceCurrency: vOptional(vCurrency()),
  bidExpirationLocal: vOptional(vString()),
})

export type SpotQuotePreviewDTO = vOutput<typeof spotQuotePreviewSchema>
export interface SpotQuotePreviewResponse {
  content: string
}
